import React from "react";
import { SeparatorContainer, SeparatorText } from "./StepTimeSeparator.styled";
import { CalendarIcon, RightArrowIcon } from "../../../../components/Icons";
import { colors } from "../../../../theme/colors";
import { Box } from "@mui/material";

interface AppointmentTimeSeparatorProps {
  timeframeLabel: string;
}

/**
 * Time separator between appointments
 */
const AppointmentTimeSeparator: React.FC<AppointmentTimeSeparatorProps> = ({
  timeframeLabel,
}) => {
  if (!timeframeLabel) return null;

  return (
    <SeparatorContainer>
      <SeparatorText>
        <CalendarIcon fill={colors.text.link} />
        {timeframeLabel}
        <Box sx={{ transform: "rotate(90deg)" }}>
          <RightArrowIcon fill={colors.text.link} />
        </Box>
      </SeparatorText>
    </SeparatorContainer>
  );
};

export default AppointmentTimeSeparator;
